"use client";

import { c as _c } from "react/compiler-runtime";
import { oidcClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";
import { env } from "@/env.mjs";
export const authAdminClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_ROOT_URL,
  plugins: [organizationClient(), oidcClient()]
});
export const useAuthStoreClient = baseURL => {
  const $ = _c(2);
  let t0;
  let t1;
  if ($[0] !== baseURL) {
    t1 = createAuthClient({
      baseURL,
      plugins: []
    });
    $[0] = baseURL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  return t0;
};